import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { EsportsSlideListComponent } from "./esports-slide-list/esports-slide-list.component";

const routes: Routes = [
  {
    path: "esports-slides",
    component: EsportsSlideListComponent,
    canActivate: [AuthGuard],
  },
];

export const EsportsSlidesRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/esports-slides.routes.ts